import React, { useEffect, useMemo, useState } from 'react';
import axios from '../../axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/core/styles';
import Spinner from 'react-spinkit';
import Select from 'react-select';
import Switch from 'react-switch';
import Backdrop from '@material-ui/core/Backdrop';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  Input,
  Label,
  CardBody,
  Button,
  Table,
  FormFeedback,
} from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Divider } from '@material-ui/core';
import { styled } from '@mui/system';
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import toastr from "toastr"
import "toastr/build/toastr.min.css";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  dialogpaper: {
    width: '1200px',
  },
}));

const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: '#3F7D58',
  color: '#yourCustomTextColor',
  '&:hover': {
    backgroundColor: '#2c3e50',
  },
});

function UserMaster() {
  const [tokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );
  const pages = [5, 10, 15, 20, 25];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  const [User, setUser] = useState([]);
  const [dailoa1, setdailoa1] = useState(false);
  const classes = useStyles();
  const [edit, setedit] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [modal, setModal] = useState(false);
  const [sweetAlert, setSweetAlert] = useState({
    message: '',
    type: 'success',
  });
  const [initialValue] = useState({
    UserId: 0,
    UserCode: '',
    UserName: '',
    Password: '',
    Department: '',
    DepartmentId: '',
    Designation: '',
    DesignationId: '',
    EmailId: '',
    CreatedBy: 0,
    CreatedDate: '',
    ModifyBy: 0,
    ModifyDate: '',
    OpType: '',
    AdminUser: 'N',
    SpecialUser: 'N',
    SalesMan: 'N',
    CustomerLog: 'N',
    BranchLog: 'N',
    AuthUser: 'N',
    TransAlertReqd: 'N',
    PaymentFollowUpAlert: 'N',
    SalesInvAlert: 'N',
    UserActive: 'Y',
    PhoneNo: '',
    MobileNo: '',
    NewPassword: '',
    CreditAccess: 'N',
    CreditPassword: '',
  });
  const [customerNameHelpData, setcustomerNameHelpData] = useState([]);
  const [designationHelpData, setDesignationHelpData] = useState([]);

  const GetAllDepartment = async () => {
    setdailoa1(true);
    try {
      const res = await axios.instance.get(`Department/GetAllDepartment`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const data = res.data;
      const options = data.map(b => ({
        label: b.DepartmentDescription,
        value: b.DepartmentId,
      }));
      setcustomerNameHelpData(options);
    } catch (e) {
      console.error('Error fetching departments:', e.message);
      setSweetAlert({
        message: e.response ? e.response.data : 'Failed to fetch departments',
        type: 'warning',
      });
    } finally {
      setdailoa1(false);
    }
  };

  const GetAllDesignations = async () => {
    setdailoa1(true);
    try {
      const res = await axios.instance.get(`/Designation/GetAllDesignation`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const data = res.data;
      const options = data.map(b => ({
        label: b.DesignationDescription,
        value: b.DesignationId,
      }));
      setDesignationHelpData(options);
    } catch (e) {
      console.error('Error fetching designations:', e.message);
      setSweetAlert({
        message: e.response ? e.response.data : 'Failed to fetch designations',
        type: 'warning',
      });
    } finally {
      setdailoa1(false);
    }
  };

  const formikValidation = useFormik({
    initialValues: initialValue,
    validationSchema: Yup.object({
      UserName: Yup.string()
        .required('Enter User Name')
        .max(50, 'Cannot contain more than 50 Characters'),
      UserCode: Yup.string()
        .required('Enter User Code')
        .max(10, 'Cannot contain more than 10 Characters'),
      Password: Yup.string()
        .required('Enter Password')
        .max(10, 'Cannot contain more than 10 Characters'),
      EmailId: Yup.string()
        .email('Enter a valid Email ID')
        .required('Enter Email ID')
        .max(50, 'Cannot contain more than 50 Characters'),
      DepartmentId: Yup.string().required('Department is required'),
      DesignationId: Yup.string().required('Designation is required'),
      UserActive: Yup.string()
        .required('Enter User Active status')
        .max(1, 'Only 1 character allowed'),
      CreatedBy: Yup.number()
        .required('Enter Created By')
        .integer('Must be an integer'),
      ModifyBy: Yup.number().integer('Must be an integer'),
      PhoneNo: Yup.string()
        .matches(/^[0-9]{10}$/, 'Enter a valid 10-digit phone number')
        .max(50, 'Cannot contain more than 50 Characters'),
      MobileNo: Yup.string()
        .matches(/^[0-9]{10}$/, 'Enter a valid 10-digit mobile number')
        .max(50, 'Cannot contain more than 50 Characters'),
      NewPassword: Yup.string().max(
        10,
        'Cannot contain more than 10 Characters',
      ),
      CreditPassword: Yup.string().max(
        10,
        'Cannot contain more than 10 Characters',
      ),
    }),
    onSubmit: values => {
      InsertUserData(values);
    },
  });

  useEffect(() => {
    GetAllUser();
    GetAllDepartment();
    GetAllDesignations();
  }, []);

  const GetAllUser = async () => {
    try {
      setdailoa1(true);
      const res = await axios.instance.get(`UserMaster/GetAllUser`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUser(res.data);
    } catch (e) {
      console.log('Error', e.message);
    }
    setdailoa1(false);
  };

  const InsertUserData = async values => {
    console.log('insert values', values);
    try {
      setdailoa1(true);
      // Find department and designation labels
      const department = customerNameHelpData.find(
        d => d.value === values.DepartmentId,
      );
      const designation = designationHelpData.find(
        d => d.value === values.DesignationId,
      );
      console.log('department', department);
      console.log('designation', designation);

      await axios.instance.post(
        `UserMaster/InsertUser`,

        {
          ...values,
          Department: department.label,
          DepartmentID: department.value,
          Designation: designation.label,
          DesignationID: designation.value,
          OpType: edit ? 'edit' : 'new',
          [edit ? 'ModifyBy' : 'CreatedBy']: sessionStorage.getItem('Userid'),
          [edit ? 'ModifyDate' : 'CreatedDate']: new Date(),
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      );
      setSweetAlert({
        message: `User ${edit ? 'Updated' : 'Added'} Successfully`,
        type: 'success',
      });
      GetAllUser();
      handleModalClose();
    } catch (e) {
      console.log(e.message, e.response ? e.response.data : e.message);
      setSweetAlert({
        message: e.response ? e.response.data : 'Something went wrong',
        type: 'warning',
      });
    }
    setdailoa1(false);
  };

  const handleDelete = async () => {
    try {
      setdailoa1(true);
      await axios.instance.post(
        `UserMaster/InsertUser`,
        {
          UserId: deleteId,
          OpType: 'Delete',
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      ).then(res=>{
        console.log('Delete response:', res.data);
        if(res.data.length==0){
          setSweetAlert({
            message: `User Deleted Successfully`,
            type: 'success',
          });
        }else{
          toastr.error("User can't be deleted, it is used in other modules");
        }
      })
    
      GetAllUser();
      setDeleteId(null);
    } catch (e) {
      console.log(e.message, e.response ? e.response.data : e.message);
      setSweetAlert({
        message: e.response ? e.response.data : 'Something went wrong',
        type: 'warning',
      });
    }
    setdailoa1(false);
  };

  const filteredUser = useMemo(() => {
    return User.slice(page * rowsperpage, (page + 1) * rowsperpage);
  }, [User, page, rowsperpage]);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
  };

  const handleModalClose = () => {
    setModal(false);
    formikValidation.resetForm();
    setedit(false);
  };

  const handleModalOpen = () => {
    setModal(true);
  };

  const handleEditClick = data => {
    // Map API response to form values
    formikValidation.setValues({
      UserId: data.User_Id,
      UserCode: data.User_Code,
      UserName: data.User_Name,
      Password: data.Password,
      Department: data.Department,
      DepartmentId: data.DepartmentID,
      Designation: data.Designation,
      DesignationId: data.DesignationID,
      EmailId: data.Emailid,
      UserActive: data.User_Active,
      CreatedBy: data.Created_By,
      CreatedDate: data.Created_Date,
      ModifyBy: data.Modify_By || 0,
      ModifyDate:
        data.Modify_Date === '1900-01-01T00:00:00.000Z' ? '' : data.Modify_Date,
      OpType: 'edit',
      AdminUser: data.AdminUser,
      SpecialUser: data.Special_User,
      SalesMan: data.SalesMan,
      CustomerLog: data.Customer_Log,
      BranchLog: data.Branch_Log,
      AuthUser: data.Auth_User,
      TransAlertReqd: data.Trans_Alert_Reqd,
      PaymentFollowUpAlert: data.PaymentFollowUpAlert,
      SalesInvAlert: data.SalesInvAlert,
      PhoneNo: data.PhoneNo,
      MobileNo: data.MobileNo,
      NewPassword: data.New_Password || '',
      CreditAccess: data.Credit_Access,
      CreditPassword: data.Credit_Password || '',
    });

    setedit(true);
    handleModalOpen();
  };
  return (
    <React.Fragment>
      <div className="page-content" style={{ backgroundColor: 'inherit' }}>
        <div className="">
          <Row>
            <Col xs="12">
              <h6 className="titleviewinspections">User Master</h6>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >
                      <CustomButton
                        variant="contained"
                        onClick={handleModalOpen}
                        size="small"
                      >
                        Add User
                      </CustomButton>
                    </Col>
                  </div>
                  <div className="Tabelinspections">
                    <TableContainer>
                      <Table className="InspectionTbls">
                        <TableHead>
                          <TableRow>
                            <TableCell>User Code </TableCell>
                            <TableCell align="left">User Name</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {User.length != 0 ? (
                            filteredUser.map(data => (
                              <TableRow key={data.UserId}>
                                <TableCell style={{ textAlign: 'left' }}>
                                  {data.User_Code}
                                </TableCell>
                                <TableCell style={{ textAlign: 'left' }}>
                                  {data.User_Name}
                                </TableCell>
                                <TableCell align="left">
                                  <IconButton size="small">
                                    <EditIcon
                                      fontSize="small"
                                      color="primary"
                                      onClick={() => {
                                        handleEditClick(data);
                                      }}
                                    />
                                  </IconButton>
                                  <IconButton size="small">
                                    <DeleteIcon
                                      color="error"
                                      fontSize="small"
                                      onClick={() => {
                                        setDeleteConfirm(true);
                                        setDeleteId(data.User_Id);
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableCell align="left">NO Data Found</TableCell>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TablePagination
                      component="div"
                      rowsPerPageOptions={pages}
                      count={User.length}
                      rowsPerPage={rowsperpage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={handleModalClose} size="xl">
            <ModalHeader toggle={handleModalClose} tag="h4">
              {edit ? 'Edit' : 'Add'} User
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg={3} md={6}>
                  <Label for="basicpill-firstname-input1">User Code</Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="UserCode"
                    value={formikValidation.values.UserCode}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.UserCode &&
                        formikValidation.touched.UserCode
                      )
                    }
                  />
                  {formikValidation.touched.UserCode &&
                    formikValidation.errors.UserCode && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.UserCode}
                      </FormFeedback>
                    )}
                </Col>
                <Col lg={3} md={6}>
                  <Label for="basicpill-firstname-input1">User Name</Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="UserName"
                    value={formikValidation.values.UserName}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.UserName &&
                        formikValidation.touched.UserName
                      )
                    }
                  />
                  {formikValidation.touched.UserName &&
                    formikValidation.errors.UserName && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.UserName}
                      </FormFeedback>
                    )}
                </Col>
                <Col lg={3} md={6}>
                  <Label for="basicpill-firstname-input1">Password</Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="Password"
                    value={formikValidation.values.Password}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.Password &&
                        formikValidation.touched.Password
                      )
                    }
                  />
                  {formikValidation.touched.Password &&
                    formikValidation.errors.Password && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.Password}
                      </FormFeedback>
                    )}
                </Col>
                <Col lg={3} md={6}>
                  <div className="mb-2">
                    <Label htmlFor="manufacturerbrand">
                      <b>Department </b> <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Select
                      options={customerNameHelpData}
                      classNamePrefix="select2-search-disable"
                      value={customerNameHelpData.find(
                        option =>
                          option.value === formikValidation.values.DepartmentId,
                      )}
                      onChange={option => {
                        formikValidation.setFieldValue(
                          'DepartmentId',
                          option.value,
                        );
                      }}
                      onBlur={formikValidation.handleBlur}
                      name="DepartmentId"
                    />
                    {formikValidation.touched.DepartmentId &&
                      formikValidation.errors.DepartmentId && (
                        <div
                          className="text-danger"
                          style={{ fontSize: '0.8rem' }}
                        >
                          {formikValidation.errors.DepartmentId}
                        </div>
                      )}
                  </div>
                </Col>
                <Col lg={3} md={6}>
                  <div className="mb-2">
                    <Label htmlFor="manufacturerbrand">
                      <b>Designation </b>{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Select
                      options={designationHelpData}
                      classNamePrefix="select2-search-disable"
                      value={designationHelpData.find(
                        option =>
                          option.value ===
                          formikValidation.values.DesignationId,
                      )}
                      onChange={option => {
                        formikValidation.setFieldValue(
                          'DesignationId',
                          option.value,
                        );
                      }}
                      onBlur={formikValidation.handleBlur}
                      name="DesignationId"
                    />
                    {formikValidation.touched.DesignationId &&
                      formikValidation.errors.DesignationId && (
                        <div
                          className="text-danger"
                          style={{ fontSize: '0.8rem' }}
                        >
                          {formikValidation.errors.DesignationId}
                        </div>
                      )}
                  </div>
                </Col>
                <Col lg={3} md={6}>
                  <Label for="basicpill-firstname-input1">EmailId</Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="EmailId"
                    value={formikValidation.values.EmailId}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.EmailId &&
                        formikValidation.touched.EmailId
                      )
                    }
                  />
                  {formikValidation.touched.EmailId &&
                    formikValidation.errors.EmailId && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.EmailId}
                      </FormFeedback>
                    )}
                </Col>
                <Col lg={3} md={6}>
                  <Label for="basicpill-firstname-input1">PhoneNo</Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="PhoneNo"
                    value={formikValidation.values.PhoneNo}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.PhoneNo &&
                        formikValidation.touched.PhoneNo
                      )
                    }
                  />
                  {formikValidation.touched.PhoneNo &&
                    formikValidation.errors.PhoneNo && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.PhoneNo}
                      </FormFeedback>
                    )}
                </Col>
                <Col lg={3} md={6}>
                  <Label for="basicpill-firstname-input1">MobileNo</Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="MobileNo"
                    value={formikValidation.values.MobileNo}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.MobileNo &&
                        formikValidation.touched.MobileNo
                      )
                    }
                  />
                  {formikValidation.touched.MobileNo &&
                    formikValidation.errors.MobileNo && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.MobileNo}
                      </FormFeedback>
                    )}
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'UserActive',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.UserActive === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">Active</Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'AdminUser',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.AdminUser === 'Y'}
                      width={40}
                      height={20}
                      disabled={true}
                    />
                    <Label className="mb-0 font-size-14 ml-2">Admin User</Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'SpecialUser',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.SpecialUser === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">
                      Special User
                    </Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'SalesMan',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.SalesMan === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">Salesman</Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'CustomerLog',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.CustomerLog === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">
                      Customer Log
                    </Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'BranchLog',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.BranchLog === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">Branch Log</Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'AuthUser',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.AuthUser === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">Auth User</Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'TransAlertReqd',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.TransAlertReqd === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">
                      Transaction Alert
                    </Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'PaymentFollowUpAlert',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={
                        formikValidation.values.PaymentFollowUpAlert === 'Y'
                      }
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">
                      Payment Follow Up
                    </Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'SalesInvAlert',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.SalesInvAlert === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">
                      Sales Invoice Alert
                    </Label>
                  </div>
                </Col>

                <Col xl={3} className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <Switch
                      onChange={checked => {
                        formikValidation.setFieldValue(
                          'CreditAccess',
                          checked ? 'Y' : 'N',
                        );
                      }}
                      checked={formikValidation.values.CreditAccess === 'Y'}
                      width={40}
                      height={20}
                    />
                    <Label className="mb-0 font-size-14 ml-2">
                      Credit Access
                    </Label>
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-center ">
                <Button
                  color="primary"
                  style={{ backgroundColor: '#3468C0', color: 'white' }}
                  onClick={() => {
                    formikValidation.submitForm();
                  }}
                >
                  {edit ? 'Update' : 'Save'}
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <Backdrop open={dailoa1} className={classes.backdrop}>
            <Spinner name="ball-spin-fade-loader" color="#fafafa" />
          </Backdrop>

          {deleteConfirm && (
            <SweetAlert
              title="Are You Sure?"
              style={{
                position: 'absolute',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              confirmBtnBsStyle="success"
              showConfirm={true}
              cancelBtnBsStyle="danger"
              cancelBtnText="Cancel"
              confirmBtnText="Yes,delete it!"
              showCancel={true}
              warning
              onConfirm={() => {
                handleDelete();
                setDeleteConfirm(false);
              }}
              onCancel={() => {
                setDeleteConfirm(false);
                setDeleteId(null);
              }}
            >
              <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
            </SweetAlert>
          )}

          {sweetAlert.message && (
            <SweetAlert
              title={sweetAlert.message}
              timeout={2000}
              style={{
                position: 'absolute',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              showCloseButton={false}
              showConfirm={false}
              type={sweetAlert.type}
              onConfirm={() => {
                setSweetAlert({
                  message: '',
                  type: 'success',
                });
              }}
            ></SweetAlert>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default UserMaster;
